export default __webpack_public_path__ + "static/media/single-project-page-01-img22.a3ca2057.jpg";